import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { PlayerType, RoutePage } from '@/interface/enum';
import { getSportsUrl } from '@/libraries/url';
import { useAccountStore } from '@/stores/accountStore';
import { useFeatureToggleStore } from '@/stores/featureToggleStore';
import { useRootStore } from '@/stores/rootStore';

export default function useTournamentCenterEntrance() {
    const router = useRouter();
    const { customerInfo } = storeToRefs(useAccountStore());
    const { isAsi, isMixParlayMode } = storeToRefs(useRootStore());

    const route = computed(() => {
        if (!isAsi.value) {
            return router.resolve({ name: RoutePage.TournamentCenterOverview });
        }

        const isB2BPlayer = customerInfo.value.playerType === PlayerType.B2B;
        const routeName = isB2BPlayer
            ? RoutePage.TournamentCenterMatches
            : RoutePage.TournamentCenterOverview;

        return router.resolve({ name: routeName });
    });

    const path = computed(() => {
        if (!isAsi.value) {
            return 'tournament-center';
        }

        const isB2BPlayer = customerInfo.value.playerType === PlayerType.B2B;
        return isB2BPlayer ? 'tournament-center/matches' : 'tournament-center';
    });

    const url = computed(() => `${getSportsUrl()}/${path.value}`);

    const {
        isTournamentCenterEnabled,
        isTournamentCenterEntranceEnabled,
        isTournamentCenterSportListEntranceEnabled,
        isTournamentCenterMainPageEntranceEnabled,
    } = storeToRefs(useFeatureToggleStore());

    const isShowTournamentCenterEntrance = computed(
        () => isTournamentCenterEnabled.value && isTournamentCenterEntranceEnabled.value && !isMixParlayMode.value,
    );

    const isShowTournamentCenterSportListEntrance = computed(
        () => isTournamentCenterEnabled.value && isTournamentCenterSportListEntranceEnabled.value,
    );

    const isShowTournamentCenterMainPageEntrance = computed(
        () => isTournamentCenterEnabled.value && isTournamentCenterMainPageEntranceEnabled.value,
    );

    return {
        route,
        url,
        isShowTournamentCenterEntrance,
        isShowTournamentCenterSportListEntrance,
        isShowTournamentCenterMainPageEntrance,
    };
}
